import { render, staticRenderFns } from "./MySwiper.vue?vue&type=template&id=24ceb788&scoped=true&"
import script from "./MySwiper.vue?vue&type=script&lang=ts&"
export * from "./MySwiper.vue?vue&type=script&lang=ts&"
import style0 from "./MySwiper.vue?vue&type=style&index=0&id=24ceb788&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ceb788",
  null
  
)

export default component.exports